import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { UtilsModule } from '@mysvg/utils';
import { ActivityModule } from '@svg-frontends/activity';
import { SessionModule } from '@svg-frontends/session';
import { ThemingModule } from '@svg-frontends/theming';

/*
	Modules which are core to the app and e.g. export directives which are essential.
	Helps to not import the same module over and over.
	Do not carelessly remove module exports from this library.
	It re exports some libraries that contain structural directives (activity, utils module etc.).
	This would lead to tricky runtime errors in the parts depending on this module to get those directives.
*/
const MODULES = [CommonModule, ActivityModule, SessionModule, UtilsModule, ThemingModule];

@NgModule({
	imports: MODULES,
	exports: MODULES,
})
export class CoreImportsModule {}
